import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { Grid, Select, MenuItem, Input, Button } from "@material-ui/core";
import "react-datetime/css/react-datetime.css";

import SelectGender from "../../partials/selectGender";
import InputFormat from "../../partials/inputForm";
import { _parsePhoneNumber } from "../../partials/validateNumber";

import { details as styles } from "./styles";
import { formatDatetime } from "../../utils/setting";

class ListCampaign extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  updateStatusUser = (data, value) => {
    this.props.updateStatusUser({ userCode: data.userCode, active: value });
  };

  render() {
    const { t, classes, data = {}, disabled = true, spa = {} } = this.props;
    return (
      <div className={classes.root}>
        <Grid container spacing={3}>
          <Grid item md={6}>
            <Select
              value={data.active}
              onChange={(e) => {
                this.updateStatusUser(data, e.target.value);
              }}
              name="status"
              input={
                <Input
                  name="status"
                  disableUnderline={true}
                  fullWidth
                  style={{
                    color:
                      data.active === 1
                        ? "rgb(45, 178, 83)"
                        : "rgb(145, 145, 145)",
                    fontWeight: "500",
                  }}
                />
              }
              displayEmpty
              classes={{
                selectMenu: classes.selectedMenu,
                root: classes.selectedRoot,
              }}
              MenuProps={{
                transitionDuration: 10,
              }}
            >
              {[
                {
                  value: 1,
                  label: "active",
                  color: "rgb(45, 178, 83)",
                },
                {
                  value: 0,
                  label: "inActive",
                  color: "rgb(145, 145, 145)",
                },
              ].map((item, index) => (
                <MenuItem key={index} value={item.value}>
                  <Button
                    classes={{
                      root: classes.btnStatus,
                    }}
                    size="small"
                    style={{ backgroundColor: item.color, color: "#fff" }}
                  >
                    {t(item.label)}
                  </Button>
                </MenuItem>
              ))}
            </Select>
          </Grid>
          <Grid item md={6}>
            <InputFormat
              label={t("countrycode_code")}
              name="countryCode"
              value={data.countryCode}
              disabled={disabled}
            />
          </Grid>
          <Grid item md={6}>
            <InputFormat
              label={t("username")}
              name="username"
              value={data.username}
              disabled={disabled}
            />
          </Grid>
          <Grid item md={6}>
            <InputFormat
              label={t("profile_first_name")}
              name="firstName"
              value={data.firstName}
              disabled={disabled}
            />
          </Grid>
          <Grid item md={6}>
            <InputFormat
              label={t("profile_last_name")}
              name="lastName"
              value={data.lastName}
              disabled={disabled}
            />
          </Grid>
          <Grid item md={6}>
            <InputFormat
              label={t("profile_phone")}
              name="mobile"
              value={data.mobile}
              disabled={disabled}
            />
          </Grid>
          <Grid item md={6}>
            <InputFormat
              label={t("user_detail_email")}
              name="email"
              value={data.email}
              disabled={disabled}
            />
          </Grid>
          <Grid item md={6}>
            <InputFormat
              label={t("user_detail_birthday")}
              name="dob"
              value={data.dob}
              disabled={disabled}
            />
          </Grid>
          <Grid item md={6}>
            <SelectGender
              label={t("user_detail_gender")}
              name="gender"
              value={data.visitor}
              disabled={disabled}
            />
          </Grid>
          <Grid item md={6}>
            <InputFormat
              label={t("user_detail_address")}
              name="address"
              value={data.address}
              disabled={disabled}
            />
          </Grid>
          <Grid item md={6}>
            <InputFormat
              label={t("user_detail_visitor")}
              name="visitor"
              value={data.visitor}
              disabled={disabled}
            />
          </Grid>
          <Grid item md={6}>
            <InputFormat
              label={t("user_detail_login_time")}
              name="loginTime"
              value={formatDatetime(data.loginTime)}
              disabled={disabled}
            />
          </Grid>
        </Grid>
      </div>
    );
  }
}

ListCampaign.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({});
export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(ListCampaign)
  )
);
